import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initialSelect2();
    this.setFormRequestRecurringVisibility();
    this.setFormRequestAssigneeVisibility();
    this.setTimeVisibility();
    this.setEventRecurringVisibility();
    this.setDrugTestRequestRecurringVisibility();
    this.setSurveyRequestAssigneeVisibility();
    this.setSurveyRequestRecurringVisibility();
    this.setGoalAssigneeVisibility();
    this.setGoalRecurringVisibility();
    this.setClientNotifyAtVisibility();
    this.setStaffNotifyAtVisibility();
    this.setReviewerNotifyAtVisibility();
  }

  initialSelect2() {
    // For form request
    $("#form_request_due_date").datepicker({
      autoclose: true,
      startDate: new Date()
    });

    $("#form_request_first_create_date").datepicker({
      autoclose: true,
      startDate: new Date()
    });

    // checkins and events
    $('#event_date_time_range .date').datepicker({
      autoclose: true
    });

    $('#event_date_time_range .time').timepicker({
      showDuration: true,
      timeFormat: 'g:ia'
    });

    $("#new_checkin #event_address").select2({
      width: '100%',
      tags: true
    });

    $("#drug_test_request_due_date").datepicker({
      autoclose: true,
      startDate: new Date((new Date()).getTime() + 1 * (24 * 60 * 60 * 1000))
    });

    $("#drug_test_request_blacklist_dates").datepicker({
      autoclose: true,
      startDate: new Date((new Date()).getTime() + 2 * (24 * 60 * 60 * 1000))
    });

    $('#drug_test_request_notify_at .time').timepicker({
      showDuration: true,
      timeFormat: 'g:ia'
    });

    $('#drug_test_request_staff_notify_at .time').timepicker({
      showDuration: true,
      timeFormat: 'g:ia'
    });

    $('#drug_test_request_reviewer_notify_at .time').timepicker({
      showDuration: true,
      timeFormat: 'g:ia'
    });

    // Goals
    $('#goal_due, #goal_first_create_date').datepicker({
      autoclose: true,
      startDate: new Date()
    });

    $('#goal_due_time, #form_request_due_time, #survey_request_due_time').timepicker({
      showDuration: true,
      timeFormat: 'g:ia'
    });

    $("#goal_assignee_id").select2({
      width: '100%',
      allowClear: true
    });

    // Other
    $("#survey_request_due_date").datepicker({
      autoclose: true,
      startDate: new Date()
    });

    $("#survey_request_first_create_date").datepicker({
      autoclose: true,
      startDate: new Date()
    });
  }

  // For event
  setTimeVisibility() {
    const isEventAllDay = String($('#event_all_day').val()).toLowerCase() === 'true';
    if (isEventAllDay) {
      $('.event_start_date').removeClass('col-6').addClass('col-12');
      $('.event_end_date').removeClass('col-6').addClass('col-12');
      $('#event_start_time').hide();
      $('#event_end_time').hide();
    } else {
      $('#event_start_time').show();
      $('#event_end_time').show();
      $('.event_start_date').removeClass('col-12').addClass('col-6');
      $('.event_end_date').removeClass('col-12').addClass('col-6');
    }
  };

  setEventRecurringVisibility() {
    if ($('#event_is_recurring').val() === 'false') {
      $('.recurrence_rule').hide();
    } else {
      $('.recurrence_rule').show();
    }
  };

  // For form request
  setFormRequestRecurringVisibility() {
    if ($('#form_request_is_recurring').val() === 'false') {
      $('.form_request_recurrence_rule').hide();
      $("label[for='form_request_due_date']").text("Due Date");
      $('#form_request_first_create_date').val('');
    } else {
      $("label[for='form_request_due_date']").text("When would you like the first form request to be due?");
      $('.form_request_recurrence_rule').show();
    }
  }

  setFormRequestAssigneeVisibility() {
    if ($('#form_request_is_assigned').val() === 'false') {
      $('.form_request_assignee_id').hide();
    } else {
      $('.form_request_assignee_id').show();
    }
  }

  // Drug test requst
  setDrugTestRequestRecurringVisibility() {
    if ($('#drug_test_request_is_recurring').val() === 'false') {
      $('.drug_test_request_recurrence_rule').hide();
      $("label[for='drug_test_request_due_date']").text("Due Date");
    } else {
      $('.drug_test_request_recurrence_rule').show();
      $("label[for='drug_test_request_due_date']").text("On which date would you like the randomizer to start assigning Drug Test request?");
    }
  };

  // For survey request
  setSurveyRequestAssigneeVisibility() {
    if ($('#survey_request_is_assigned').val() === 'false') {
      $('.survey_request_assignee_id').hide();
    } else {
      $('.survey_request_assignee_id').show();
    }
  };

  setSurveyRequestRecurringVisibility() {
    if ($('#survey_request_is_recurring').val() === 'false') {
      $('.survey_request_recurrence_rule').hide();
      $('#survey_request_first_create_date').val('');
      $("label[for='survey_request_due_date']").text("Due Date");
    } else {
      $('.survey_request_recurrence_rule').show();
      $("label[for='survey_request_due_date']").text("When would you like the first survey request to be due?");
      $('#survey_request_first_create_date');
    }
  };

  // For goals
  setGoalAssigneeVisibility() {
    if ($('#goal_is_assigned').val() === 'false') {
      $('.goal_assignee_id').hide();
    } else {
      $('.goal_assignee_id').show();
    }
  };

  setGoalRecurringVisibility() {
    if ($('#goal_is_recurring').val() === 'false') {
      $("label[for='goal_due']").text("Due Date");
      $('.goal_recurrence_rule').hide();
      $('#goal_first_create_date').val('');
    } else {
      $("label[for='goal_due']").text("When would you like the first goal to be due?");
      $('.goal_recurrence_rule').show();
      $('#goal_first_create_date');
    }
  };

  setClientNotifyAtVisibility(event){
    const selectedValue = event.target.value;
    if (selectedValue === 'true'){
      $('.drug_test_request_notify_at').show();
      $('#drug_test_request_notify_at').removeClass('collapse');
    }
    else {
      $('.drug_test_request_notify_at').hide();
      $('#drug_test_request_notify_at').addClass('collapse');
      $('#drug_test_request_notify_at').val('');
    }
  }

  setStaffNotifyAtVisibility(event){
    const selectedValue = event.target.value;
    if (selectedValue === 'true'){
      $('.drug_test_request_staff_notify_at').show();
      $('#drug_test_request_staff_notify_at').removeClass('collapse');
    }
    else {
      $('.drug_test_request_staff_notify_at').hide();
      $('#drug_test_request_staff_notify_at').addClass('collapse');
      $('#drug_test_request_staff_notify_at').val('');
    }
  }

  setReviewerNotifyAtVisibility(event){
    const selectedValue = event.target.value;
    if (selectedValue === 'true'){
      $('.drug_test_request_reviewer_notify_at').show();
      $('#drug_test_request_reviewer_notify_at').removeClass('collapse');
    }
    else {
      $('.drug_test_request_reviewer_notify_at').hide();
      $('#drug_test_request_reviewer_notify_at').val('');
      $('#drug_test_request_reviewer_notify_at').addClass('collapse');
    }
  }
}
